export default "__VITE_ASSET__BC9F8ikj__"